import {PulseIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu} from '@primer/react'

import {useActivityAnalytics} from '../hooks/use-activity-analytics'
import type {ActivityType} from '../types/activity-types'

const orderedTypes: ActivityType[] = [
  'all',
  'direct_push',
  'pr_merge',
  'merge_queue_merge',
  'force_push',
  'branch_creation',
  'branch_deletion',
]

const activityTypeLabels: Record<ActivityType, string> = {
  all: 'All activity',
  // eslint-disable-next-line camelcase
  direct_push: 'Direct pushes',
  // eslint-disable-next-line camelcase
  pr_merge: 'Pull request merges',
  // eslint-disable-next-line camelcase
  merge_queue_merge: 'Merge queue merges',
  // eslint-disable-next-line camelcase
  force_push: 'Force pushes',
  // eslint-disable-next-line camelcase
  branch_creation: 'Branch creations',
  // eslint-disable-next-line camelcase
  branch_deletion: 'Branch deletions',
}

export function ActivityTypeFilter({
  currentActivityType,
  onSelect,
}: {
  currentActivityType: ActivityType
  onSelect: (activityType: ActivityType) => void
}) {
  const {sendActivityClickEvent} = useActivityAnalytics()
  return (
    <ActionMenu onOpenChange={open => open && sendActivityClickEvent('ACTIVITY_FILTER')}>
      <ActionMenu.Button leadingVisual={PulseIcon} size="medium">
        {activityTypeLabels[currentActivityType]}
      </ActionMenu.Button>
      <ActionMenu.Overlay width="medium">
        <ActionList selectionVariant="single">
          {orderedTypes.map(type => (
            <ActionList.Item
              key={type}
              selected={type === currentActivityType}
              onSelect={() => {
                sendActivityClickEvent('ACTIVITY_FILTER.VALUE', {['selected_activity_type']: type})
                onSelect(type)
              }}
            >
              {activityTypeLabels[type]}
            </ActionList.Item>
          ))}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
